"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
// The box a target-temperature modulation is allowed to search in. The server held these
// hardcoded at 0-10 m/s, 150000 l/h and 200 kPa - wide enough to be no constraint at all, ten
// metres a second being several times what a supplier will build for - so the tool could
// settle on a duty point no real coil would run at and report it without comment. Those same
// numbers are the start-up values here, so nothing changes until someone tightens them.
//
// Shown only for a fluid coil calculating to a target temperature: max performance takes the
// fluid flow as an input rather than solving for it, so it has no use for them.
const fluidModulation = "calculationmethod=1";
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "constraintsminvelocity",
            group: "",
            quantity: "Velocity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString(fluidModulation),
            value: []
        },
        {
            sort_no: 2,
            name: "constraintsmaxvelocity",
            group: "",
            quantity: "Velocity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString(fluidModulation),
            value: []
        },
        {
            sort_no: 3,
            name: "constraintsmaxflow",
            group: "",
            quantity: "VolumeFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString(fluidModulation),
            value: []
        },
        {
            sort_no: 4,
            name: "constraintsmaxpressuredrop",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString(fluidModulation),
            value: []
        }
    ];
}
//# sourceMappingURL=constraints-definition.js.map